module.exports = ".root {\n  width: 300px;\n}\n\n.card {\n  width: 200px;\n  height: 200px;\n}\n\n.media {\n  height: 100px;\n  margin: 0.25rem 0;\n}\n"